module.exports = __webpack_public_path__ + "assets/img/avatar-4.38bb1b64.jpg";